class HotspotComponent extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.setupEventListeners();
    }
    setupEventListeners() {
      const dots = this.querySelectorAll('.hotspot-section-container-poster--dots');
      const products = this.querySelectorAll('.custom-product-hotspot');
      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          dots.forEach((data) => data.classList.remove('active'));
          products.forEach((product) => product.classList.add('hidden'));
          dot.classList.add('active');
          const product = this.querySelector(`#hotspot-product-${index + 1}`);
          if (product) {
            product.classList.remove('hidden');
          }
        });
      });
    }
  }
  customElements.define('hotspot-component', HotspotComponent);